// Save / Save As UI (customer report, 2026-08-28: "saves everything as
// untitled … saves over the old one"). Classic prompted for a design name on
// the FIRST save (window.prompt, L8912) and had a separate "save as new copy"
// (L8962). The v2 toolbar wired both menu items to a bare cloudSaveDesign() —
// no prompt, silent overwrite. This restores the classic flow with a modal:
//   - Save   : existing design → update in place (toast). New design → name modal.
//   - Save As: always the name modal (default "<name> (copy)") → inserts a NEW row.
import { state } from './../state'
import { el, openModal, closeModal, toast } from './../ui/dom'
import { cloudSaveDesign } from './save'
import { openAuth } from './../auth/auth-ui'
import { openUpgrade } from './../panels/upgradeModal'
import { updateStatus } from './../statusbar'

/** Small name-prompt modal; resolves the chosen name, or null on cancel. */
export function promptDesignName(title: string, defaultName: string): Promise<string | null> {
  return new Promise((resolve) => {
    let settled = false
    const settle = (v: string | null) => { if (!settled) { settled = true; resolve(v) } }
    const input = el('input', 'prop-input w-full') as HTMLInputElement
    input.type = 'text'
    input.maxLength = 100
    input.value = defaultName
    input.placeholder = 'My Label'
    const ok = el('button', 'tb-btn primary', 'Save') as HTMLButtonElement
    const cancel = el('button', 'tb-btn', 'Cancel') as HTMLButtonElement
    const submit = () => { const v = input.value.trim(); if (!v) { input.focus(); return } settle(v); closeModal() }
    ok.addEventListener('click', submit)
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') submit() })
    cancel.addEventListener('click', () => closeModal())
    openModal({
      title,
      testid: 'save-name-modal',
      width: '380px',
      body: [el('label', 'text-[11px] text-slate-400 block mb-1', 'Design name'), input],
      actions: [cancel, ok],
      onClose: () => settle(null),
    })
    input.focus()
    input.select()
  })
}

/** Toolbar entry point for Save and Save As. */
export async function saveFlow(saveAs = false): Promise<void> {
  if (!state.currentUser) { openAuth('signup'); return }

  let name: string | undefined
  if (saveAs || !state.currentDesignId) {
    const base = state.currentDesignName?.trim()
    const suggested = saveAs ? (base ? `${base} (copy)` : 'My Label') : base || 'My Label'
    const picked = await promptDesignName(saveAs ? 'Save a copy' : 'Save design', suggested)
    if (picked == null) return // cancelled
    name = picked
    if (saveAs) {
      // Fork: clear the current id so cloudSaveDesign inserts a new row.
      state.currentDesignId = null
      state.currentDesignName = name
    }
  }

  const result = await cloudSaveDesign(name)
  if (result.ok) {
    state.currentDesignName = result.name
    updateStatus()
    toast(result.action === 'insert' ? `Saved "${result.name}"` : `Saved "${result.name || 'design'}"`)
    return
  }
  if (result.reason === 'signin') openAuth('signup')
  else if (result.reason === 'limit') openUpgrade('cloud_designs')
  else toast(`Save failed${result.message ? `: ${result.message.slice(0, 120)}` : ''}`)
}
